/* eslint-disable no-unused-vars */

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import React, { FC } from 'react';
import { EmailerForm } from './EmailerForm';
import { useEmailer } from 'src/hooks/email/useEmailer';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const CreateEmailerDialog: FC<Props> = ({ open = true, onClose }) => {
  const { formik } = useEmailer({ isCreateForm: true });
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        // TODO: if mobile maybe we go full screen?
        style: { minWidth: '600px', maxWidth: '90vw' }
      }}
    >
      <DialogContent
        style={{
          padding: '1em',
          border: '1px solid black',
          display: 'flex',
          gap: '1em',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h5">Create Emailer</Typography>
        <EmailerForm isCreatePage formik={formik} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => formik.handleSubmit()}
          >
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
